import React from 'react';
import {Grid} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


function TabelleVierSpalten (props) {
  const {array,überschrift1,überschrift2,überschrift3,überschrift4,name} = props;
    
return(
  
    <Grid container spacing={0} style={{}} justifyContent={"center"} alignItems={"center"}>
       <Grid item xs={12} sm={10} md={8}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell >{überschrift1}</TableCell>
                            <TableCell >{überschrift2}</TableCell>
                            <TableCell >{überschrift3}</TableCell>
                            <TableCell >{überschrift4}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {array.map((dataObject,count) => {
                    return(
                        <TableRow key={name+" reihe"+count} >
                            <TableCell >
                                {dataObject.spalte1}
                            </TableCell>
                            <TableCell  >
                                {dataObject.spalte2}
                            </TableCell>
                            <TableCell >
                                {dataObject.spalte3}
                            </TableCell>
                            <TableCell  >
                                {dataObject.spalte4}
                            </TableCell>

                        </TableRow>
                    );})}
                     </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    </Grid>
);
}

export {TabelleVierSpalten};